import { AwardCategoryContainer } from 'containers/award/award-category/AwardCategoryContainer'
import { AwardWinnerContainer } from 'containers/award/award-winner/AwardWinnerContainer'
import { BrandNominationContainer } from 'containers/award/brand-nomination/BrandNominationContainer'
import { NominationContainer } from 'containers/award/nomination/NominationContainer'
import { ProductNominationContainer } from 'containers/award/product-nomination/ProductNominationContainer'
import { ThankYouContainer } from 'containers/award/thank-you/ThankYouContainer'
import { ExportPointMemberContainer } from 'containers/loyalty-program/export-point-member/ExportPointMemberContainer'
import { CustomerContainer } from '../containers/analytics/customer/CustomerContainer'
import { OrderContainer } from '../containers/analytics/order/OrderContainer'
import { ProductContainer } from '../containers/analytics/product/ProductContainer'
import { RevenueContainer } from '../containers/analytics/revenue/RevenueContainer'
import { VoucherContainer } from '../containers/analytics/voucher/VoucherContainer'
import { FlashSaleCreateContainer } from '../containers/flash-sale/flash-sale-create/FlashSaleCreateContainer'
import { FlashSaleListContainer } from '../containers/flash-sale/flash-sale-list/FlashSaleListContainer'
import { BeautyProfileCreateContainer } from '../containers/general-settings/beauty-profile-create/BeautyProfileCreateContainer'
import { BeautyProfileListContainer } from '../containers/general-settings/beauty-profile-list/BeautyProfileListContainer'
import { HeaderBannerContainer } from '../containers/general-settings/header-banner/HeaderBannerContainer'
import { MaintenancePageContainer } from '../containers/general-settings/maintenance-page/MaintenancePageContainer'
import { SearchPageContainer } from '../containers/general-settings/search-page/SearchPageContainer'
import { SpecialGiftCreateContainer } from '../containers/general-settings/special-gift-create/SpecialGiftCreateContainer'
import { SpecialGiftListContainer } from '../containers/general-settings/special-gift-list/SpecialGiftListContainer'
import { BenefitRedeemPointContainer } from '../containers/loyalty-program/benefit-redeem-point/BenefitRedeemPointContainer'
import { SettingPointCollectionContainer } from '../containers/loyalty-program/setting-point-collection/SettingPointCollectionContainer'
import { UserMembershipDetailContainer } from '../containers/loyalty-program/user-membership-detail/UserMembershipDetailContainer'
import { UserMembershipContainer } from '../containers/loyalty-program/user-membership/UserMembershipContainer'
import { AboutUsContainer } from '../containers/main-page/about-us/AboutUsContainer'
import { HomePageContainer } from '../containers/main-page/home-page/HomePageContainer'
import { MSBBStoreContainer } from '../containers/main-page/msbb-store/MSBBStoreContainer'
import { PartnershipContainer } from '../containers/main-page/partnership/PartnershipContainer'
import { SalePageContainer } from '../containers/main-page/sale-page/SalePageContainer'
import { FAQContainer } from '../containers/more-info-page/faq/FAQContainer'
import { PrivacyPolicyContainer } from '../containers/more-info-page/privacy-policy/PrivacyPolicyContainer'
import { ReturnPolicyContainer } from '../containers/more-info-page/return-policy/ReturnPolicyContainer'
import { ManifestContainer } from '../containers/order/manifest/ManifestContainer'
import { OrderDetailContainer } from '../containers/order/order-detail/OrderDetailContainer'
import { OrderListContainer } from '../containers/order/order-list/OrderListContainer'
import { RequestAwbContainer } from '../containers/order/request-awb/RequestAwbContainer'
import { BrandCreateContainer } from '../containers/product/brand-create/BrandCreateContainer'
import { BrandListContainer } from '../containers/product/brand-list/BrandListContainer'
import { CategoryContainer } from '../containers/product/category/CategoryContainer'
import { GiftCreateContainer } from '../containers/product/gift-create/GiftCreateContainer'
import { GiftListContainer } from '../containers/product/gift-list/GiftListContainer'
import { ProductCreateContainer } from '../containers/product/product-create/ProductCreateContainer'
import { ProductImportContainer } from '../containers/product/product-import/ProductImportContainer'
import { ProductListContainer } from '../containers/product/product-list/ProductListContainer'
import { ProductTypeContainer } from '../containers/product/product-type/ProductTypeContainer'
import { AllReviewContainer } from '../containers/reviews/all-review/AllReviewContainer'
import { ProductReviewDetailContainer } from '../containers/reviews/product-review-detail/ProductReviewDetailContainer'
import { ProductReviewContainer } from '../containers/reviews/product-review/ProductReviewContainer'
import { UserCreateContainer } from '../containers/user/user-create/UserCreateContainer'
import { UserDetailContainer } from '../containers/user/user-detail/UserDetailContainer'
import { UserListContainer } from '../containers/user/user-list/UserListContainer'
import { UserRoleCreateContainer } from '../containers/user/user-role-create/UserRoleCreateContainer'
import { UserRoleContainer } from '../containers/user/user-role/UserRoleContainer'
import { VoucherCreateContainer } from '../containers/voucher/voucher-create/VoucherCreateContainer'
import { VoucherGeneratorContainer } from '../containers/voucher/voucher-generator/VoucherGeneratorContainer'
import { VoucherListContainer } from '../containers/voucher/voucher-list/VoucherListContainer'
import { VotingListContainer } from 'containers/award/voting/voting-list/VotingListContainer'
import { CreateVotingContainer } from 'containers/award/voting/create-voting/CreateVotingContainer'
import { AnalyticVotingContainer } from 'containers/award/voting/analytic-voting/AnalyticVotingContainer'

export const ROUTE_LIST = [
    {
        path: '/user/user-list',
        component: <UserListContainer />,
    },
    {
        path: '/user/user-list/user-detail',
        component: <UserDetailContainer />,
    },
    {
        path: '/user/create-user',
        component: <UserCreateContainer />,
    },
    {
        path: '/user/user-role',
        component: <UserRoleContainer />,
    },
    {
        path: '/user/user-role/create-role',
        component: <UserRoleCreateContainer />,
    },
    {
        path: '/user/user-role/update-role',
        component: <UserRoleCreateContainer />,
    },
    {
        path: '/product/product-list',
        component: <ProductListContainer />,
    },
    {
        path: '/product/product-list/update-product',
        component: <ProductCreateContainer />,
    },
    {
        path: '/product/create-product',
        component: <ProductCreateContainer />,
    },
    {
        path: '/product/gift-list',
        component: <GiftListContainer />,
    },
    {
        path: '/product/gift-list/update-gift',
        component: <GiftCreateContainer />,
    },
    {
        path: '/product/create-gift',
        component: <GiftCreateContainer />,
    },
    {
        path: '/product/category',
        component: <CategoryContainer />,
    },
    {
        path: '/product/brand-list',
        component: <BrandListContainer />,
    },
    {
        path: '/product/create-brand',
        component: <BrandCreateContainer />,
    },
    {
        path: '/product/brand-list/update-brand',
        component: <BrandCreateContainer />,
    },
    {
        path: '/product/type-product',
        component: <ProductTypeContainer />,
    },
    {
        path: '/product/import-product',
        component: <ProductImportContainer />,
    },
    {
        path: '/order/order-list',
        component: <OrderListContainer />,
    },
    {
        path: '/order/request-awb',
        component: <RequestAwbContainer />,
    },
    {
        path: '/order/surat-jalan',
        component: <ManifestContainer />,
    },
    {
        path: '/order/:activity/detail',
        component: <OrderDetailContainer />,
    },
    {
        path: '/review/all-review',
        component: <AllReviewContainer />,
    },
    {
        path: '/review/product-review',
        component: <ProductReviewContainer />,
    },
    {
        path: '/review/product-review/detail',
        component: <ProductReviewDetailContainer />,
    },
    {
        path: '/voucher/voucher-list',
        component: <VoucherListContainer />,
    },
    {
        path: '/voucher/voucher-list/update-voucher',
        component: <VoucherCreateContainer />,
    },
    {
        path: '/voucher/create-voucher',
        component: <VoucherCreateContainer />,
    },
    {
        path: '/voucher/voucher-generator',
        component: <VoucherGeneratorContainer />,
    },
    {
        path: '/analytic/revenue',
        component: <RevenueContainer />,
    },
    {
        path: '/analytic/order',
        component: <OrderContainer />,
    },
    {
        path: '/analytic/product',
        component: <ProductContainer />,
    },
    {
        path: '/analytic/customer',
        component: <CustomerContainer />,
    },
    {
        path: '/analytic/voucher',
        component: <VoucherContainer />,
    },
    {
        path: '/flash-sale/flash-sale-list',
        component: <FlashSaleListContainer />,
    },
    {
        path: '/flash-sale/create-flash-sale',
        component: <FlashSaleCreateContainer />,
    },
    {
        path: '/flash-sale/flash-sale-list/update-flash-sale',
        component: <FlashSaleCreateContainer />,
    },
    {
        path: '/general-setting/special-gift-list',
        component: <SpecialGiftListContainer />,
    },
    {
        path: '/general-setting/special-gift-list/update-special-gift',
        component: <SpecialGiftCreateContainer />,
    },
    {
        path: '/general-setting/create-special-gift',
        component: <SpecialGiftCreateContainer />,
    },
    {
        path: '/general-setting/search-page',
        component: <SearchPageContainer />,
    },
    {
        path: '/general-setting/beauty-profile-list',
        component: <BeautyProfileListContainer />,
    },
    {
        path: '/general-setting/create-beauty-profile',
        component: <BeautyProfileCreateContainer />,
    },
    {
        path: '/general-setting/beauty-profile-list/update-beauty-profile',
        component: <BeautyProfileCreateContainer />,
    },
    {
        path: '/general-setting/header-banner',
        component: <HeaderBannerContainer />,
    },
    {
        path: '/general-setting/maintenance-page',
        component: <MaintenancePageContainer />,
    },
    {
        path: '/main-page/home-page',
        component: <HomePageContainer />,
    },
    {
        path: '/main-page/sale-page',
        component: <SalePageContainer />,
    },
    {
        path: '/main-page/about-us',
        component: <AboutUsContainer />,
    },
    {
        path: '/main-page/partnership',
        component: <PartnershipContainer />,
    },
    {
        path: '/main-page/msbb-store',
        component: <MSBBStoreContainer />,
    },
    {
        path: '/more-info/privacy-policy',
        component: <PrivacyPolicyContainer />,
    },
    {
        path: '/more-info/return-policy',
        component: <ReturnPolicyContainer />,
    },
    {
        path: '/more-info/faq',
        component: <FAQContainer />,
    },
    {
        path: '/loyalty-program/setting-point-collection',
        component: <SettingPointCollectionContainer />,
    },
    {
        path: '/loyalty-program/benefit-redeem-point',
        component: <BenefitRedeemPointContainer />,
    },
    {
        path: '/loyalty-program/user-membership',
        component: <UserMembershipContainer />,
    },
    {
        path: '/loyalty-program/user-membership/detail',
        component: <UserMembershipDetailContainer />,
    },
    {
        path: '/loyalty-program/export-point-member',
        component: <ExportPointMemberContainer />,
    },
    {
        path: '/awards/nomination',
        component: <NominationContainer />,
    },
    {
        path: '/awards/thank-you',
        component: <ThankYouContainer />,
    },
    {
        path: '/awards/winners',
        component: <AwardWinnerContainer />,
    },
    {
        path: '/awards/voting',
        component: <VotingListContainer />,
    },
    {
        path: '/awards/voting/create',
        component: <CreateVotingContainer />,
    },
    {
        path: '/awards/voting/analytic',
        component: <AnalyticVotingContainer />,
    },
    {
        path: '/awards/category-voting',
        component: <AwardCategoryContainer />,
    },
    {
        path: '/awards/product-nomination',
        component: <ProductNominationContainer />,
    },
    {
        path: '/awards/brand-nomination',
        component: <BrandNominationContainer />,
    },
]
